export class DataValue {
    public idDataType: number
    public index: number
    public value: any
    
    constructor(idDataType: number, index: number = 0, value: any = null, typeId: number = 0) {
        this.idDataType = idDataType
        this.index = index
        this.value = value
    }

    public toJSON(): any {
        return {
            IdDataType: this.idDataType,
            Index: this.index,
            Value: this.value,
        }
    }
}